const ComponentType = Object.freeze({
    ASSESSMENT: 'ASSESSMENT',
    HOMEWORK: 'HOMEWORK',
    QUESTION_BANK: 'QUESTION_BANK',
    AI_GENERATE_QUESTION: 'AI_GENERATE_QUESTION:'
});

export default ComponentType